import { render, staticRenderFns } from "./myLegalConsultation.vue?vue&type=template&id=150d5186&scoped=true&"
import script from "./myLegalConsultation.vue?vue&type=script&lang=js&"
export * from "./myLegalConsultation.vue?vue&type=script&lang=js&"
import style0 from "./myLegalConsultation.vue?vue&type=style&index=0&id=150d5186&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150d5186",
  null
  
)

export default component.exports